<div class="login-container">
  <div class="login-box">
    <div class="login-logo">
      <img src="assets/images/white-logo.png" alt="logo" class="logo" />
    </div>
    <button class="login-microsoft" (click)="loginWithMicrosoft()">
      <span>Login with Microsoft</span>
    </button>
  </div>
</div>
